import React from 'react';
import { Link } from 'react-router-dom';

export default function ProjectPreview({ project, featured = false }) {
    return (
        <article className={`project-preview project-preview--${project.id}${featured ? ' project-preview--featured' : ''}`}>
            <Link to={`/projects#${project.id}`} className="project-image" aria-label={`Read about ${project.name}`}>
                <img src={project.image} alt={project.alt} width="1440" height="900" loading="lazy" />
                <span className="project-image__open" aria-hidden="true">↗</span>
            </Link>
            <div className="project-preview__copy">
                <p className="project-category">{project.category}</p>
                <h3><Link to={`/projects#${project.id}`}>{project.name}</Link></h3>
                <p className="project-summary">{project.summary}</p>
                <ul className="project-stack" aria-label={`${project.name} technologies`}>{project.stack.map(item => <li key={item}>{item}</li>)}</ul>
                <div className="project-links"><Link to={`/projects#${project.id}`} className="text-link">Inside the project</Link><a href={project.href} target="_blank" rel="noreferrer" className="site-link">Visit site <span aria-hidden="true">↗</span><span className="sr-only"> (opens in a new tab)</span></a></div>
            </div>
        </article>
    );
}
